import axios from "axios";
import axiosUrl from "./axios.service";

const API_URL = axiosUrl.getAxiosUrl();

class FunctionalitiesUseService {
  async getAllFunctionalitiesUsed() {
    return await axios
      .get(API_URL + "functionalitiesUse/GetAllFunctionalitiesUsed")
      .then(response => {
        console.log("Functionalities used: ", response);
      });
  }

  async getAllSharedItems() {
    return await axios
      .get(API_URL + "functionalitiesUse/getAllSharedItems")
      .then(response => {
        console.log("Shared items: ", response);
      });
  }

  // Item functionality uses
  async getAllItemFunctionalities() {
    return await axios
      .get(API_URL + "functionalitiesUse/getAllItemFunctionalities")
      .then(response => {
        console.log("Item functionalities uses:   ", response);
      });
  }

  // Exporting
  async exportSharedItemsData(year, months) {
    return await axios.get(
      API_URL + "functionalitiesUse/exportSharedItemsData",
      {
        params: {
          year: year.value,
          months: months ? months.value + "" : null
        },
        responseType: "blob",
        reportProgress: true
      }
    );
  }

  async exportFunctionalitiesUsedData(year, months) {
    return await axios.get(
      API_URL + "functionalitiesUse/exportFunctionalitiesUsedData",
      {
        params: {
          year: year.value,
          months: months ? months.value + "" : null
        },
        responseType: "blob",
        reportProgress: true
      }
    );
  }

  async exportSchemesNewsVisits(year, months) {
    return await axios.get(
      API_URL + "functionalitiesUse/exportSchemesAndNewsVisits",
      {
        params: {
          year: year.value,
          months: months ? months.value + "" : null
        },
        responseType: "blob",
        reportProgress: true
      }
    );
  }

  async exportKeywordSearches(year, months) {
    return await axios.get(
      API_URL + "functionalitiesUse/exportKeywordSearches",
      {
        params: {
          year: year.value,
          months: months ? months.value + "" : null
        },
        responseType: "blob",
        reportProgress: true
      }
    );
  }

  async exportPortalUsersTable(selectedCustomersIds) {
    return await axios.get(
      API_URL + "functionalitiesUse/exportPortalUsersTable",
      {
        responseType: "blob",
        reportProgress: true,
        params: {
          customers: selectedCustomersIds.value
            ? selectedCustomersIds.value + ""
            : null
        }
      }
    );
  }
}

export default new FunctionalitiesUseService();
